import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";

import RelatorioRestantes from "../EstabelecimentoRelatorio/RelatorioRestantes";
import DrawerRelatorioRestantes from "../Drawers/DrawerRelatorio";
import ModalRelatorioRestantes from "../Modal/ModalRelatorio";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const RelatoriosRestantes = () => {
    const [relatorios, setRelatorios] = useState([]);
    const [relatorioId, setRelatorioId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarRelatorio = id => {
        setDrawerVisible(true);
        setRelatorioId(id);
    };

    const handleViewRelatorio = id => {
        setModalVisible(true);
        setRelatorioId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setRelatorioId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setRelatorioId(null);
    };

    const carregarRelatorios = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-relatorios-individuais",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setRelatorios(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar os relatórios.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setRelatorioId(null);
        carregarRelatorios();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setRelatorioId(null);
        carregarRelatorios();
    };

    useEffect(() => {
        carregarRelatorios();
    }, []);

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Relatório Individual</span>
                        </div>
                        <div className="bloco-direita">
                            <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisible(true)}
                            >
                                +
                            </Link>
                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-relatorios">
                            <div className="titulo-bloco-relatorios">Relatórios Criados</div>
                            <div className="lista-relatorios">
                                {relatorios.length === 0 &&
                                    'Nenhum relatório criado ainda. Clique no botão " + " para criar seu primeiro relatório.'}
                                {relatorios.map(relatorio => (
                                    <React.Fragment key={relatorio.id}>
                                        <RelatorioRestantes
                                            onEdit={handleEditarRelatorio}
                                            onView={handleViewRelatorio}
                                            relatorio={relatorio}
                                        />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DrawerRelatorioRestantes
                id={relatorioId}
                visible={drawerVisible}
                onClose={handleCloseDrawer}
                atualizarListagem={atualizarListagem}
            />
            <ModalRelatorioRestantes id={relatorioId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
        </>
    );
};

export default RelatoriosRestantes;
